<template>
  <div :class="{query: true, chris_inner_bg: false && $i18n.locale === 'zh-CN'}">
    <NavHome class="queryNav" v-once/>
    <router-view v-wechat-title="$t($route.meta.title) + ' - ' + $t('app.name')"></router-view>
    <Footer />
  </div>
</template>

<script>
import NavHome from './layout/NavHome'
import Footer from './layout/Footer2'

export default {
  name: 'Query',
  components: { NavHome, Footer }
}
</script>

<style scoped>
.query >>> .ex,
.query >>> .im,
.query >>> .pr{
  border: 0 none;
}
.query >>> .search-input-item .wrap .title{
  color: #656565;
  background-image: url("~@/assets/images/home/rate2.png");
}
.query >>> .search-input-item.pr .wrap .title{
  background-image: url("~@/assets/images/home/pro2.png");
}
.query >>> .search-input-item .wrap .value{
  border-color: #999;
  padding: 1px;
}
</style>


// WEBPACK FOOTER //
// src/components/Query.vue